import React from 'react';
import { prettifyNumber } from './StoreSmallItemView';
export const StorePhoneNumberView = (storePhone) => {    
    const prettyPhoneNumber = prettifyNumber(storePhone);

    return storePhone && storePhone !== '' ?
    <div className="store__item-phone"><a onClick={() => { window.location=`tel:${prettyPhoneNumber}`}}>{storePhone}</a></div> : null
};